module.exports = __webpack_public_path__ + "img/innovator-entrepreneur.78316822.svg";